export const DealTypeMap = {
  coSell: 'Co-sell',
} as const;
